(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5978],{

/***/ 68226:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-and-conditions",
      function () {
        return __webpack_require__(4928);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ terms_and_conditions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
// EXTERNAL MODULE: ./blocks/Layouts/page-layout/index.ts + 4 modules
var page_layout = __webpack_require__(80264);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./blocks/terms-and-conditions/_TermsAndConditions.module.scss
var _TermsAndConditions_module = __webpack_require__(51691);
var _TermsAndConditions_module_default = /*#__PURE__*/__webpack_require__.n(_TermsAndConditions_module);
// EXTERNAL MODULE: ./components/accordion-list/index.ts + 5 modules
var accordion_list = __webpack_require__(98736);
// EXTERNAL MODULE: ./components/text/BaseText.tsx
var BaseText = __webpack_require__(2466);
;// CONCATENATED MODULE: ./blocks/terms-and-conditions/TermsAndConditions.tsx







var TermsAndConditions = function(param) {
    var termsAndConditions = param.termsAndConditions, className = param.className;
    var termsAndConditionsContent = (0,useLocalised/* default */.Z)(translationKeys.as_a_registered_member);
    var termsAndConditionsDialogueText1 = (0,useLocalised/* default */.Z)(translationKeys.terms_and_conditions_dialogue_text_1);
    var termsAndConditionsDialogueText2 = (0,useLocalised/* default */.Z)(translationKeys.terms_and_conditions_dialogue_text_2);
    var termsAndConditionsDialogueText3 = (0,useLocalised/* default */.Z)(translationKeys.terms_and_conditions_dialogue_text_3);
    var termsAndConditionsDialogueText4 = (0,useLocalised/* default */.Z)(translationKeys.terms_and_conditions_dialogue_text_4);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)((_TermsAndConditions_module_default()).termsAndConditions, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (_TermsAndConditions_module_default()).textContentSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseText/* BaseText */.k, {
                        className: (_TermsAndConditions_module_default()).textContent,
                        children: termsAndConditionsContent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseText/* BaseText */.k, {
                        className: (_TermsAndConditions_module_default()).textContent,
                        children: termsAndConditionsDialogueText1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseText/* BaseText */.k, {
                        className: (_TermsAndConditions_module_default()).textContent,
                        children: termsAndConditionsDialogueText2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseText/* BaseText */.k, {
                        className: (_TermsAndConditions_module_default()).textContent,
                        children: termsAndConditionsDialogueText3
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseText/* BaseText */.k, {
                        className: (_TermsAndConditions_module_default()).textContent,
                        children: termsAndConditionsDialogueText4
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_list/* default */.Z, {
                items: termsAndConditions,
                getId: function(item) {
                    return "item-".concat(item.id);
                },
                getTitle: function(item) {
                    return "".concat(item.id, ". ").concat(item.title);
                },
                getContent: function(item) {
                    return [
                        item
                    ];
                },
                renderContent: function(item) {
                    var list = item.list;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (_TermsAndConditions_module_default()).accordionListContainer,
                        children: list === null || list === void 0 ? void 0 : list.map(function(listItem) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: (_TermsAndConditions_module_default()).accordionListItem,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseText/* BaseText */.k, {
                                        color: "grey-dark",
                                        weight: "demiBold",
                                        className: (_TermsAndConditions_module_default()).accordionListItemSubtitle,
                                        children: listItem.subtitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseText/* BaseText */.k, {
                                                as: "div",
                                                color: "grey-dark",
                                                className: (_TermsAndConditions_module_default()).accordionListItemDescription,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: listItem.description
                                                    }
                                                })
                                            }),
                                            listItem.innerList && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: (_TermsAndConditions_module_default()).accordionListItemInnerList,
                                                children: (ref = listItem.innerList) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (_TermsAndConditions_module_default()).accordionListItem,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseText/* BaseText */.k, {
                                                                color: "grey-dark",
                                                                weight: "demiBold",
                                                                className: (_TermsAndConditions_module_default()).accordionListItemSubtitle,
                                                                children: item.subtitle
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseText/* BaseText */.k, {
                                                                as: "div",
                                                                color: "grey-dark",
                                                                className: (_TermsAndConditions_module_default()).accordionListItemDescription,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: item.description
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }, "inner-list-item-".concat(index + 1));
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, "list-item-".concat(listItem.id));
                        })
                    }, "list-".concat(item.id));
                }
            })
        ]
    });
};
/* harmony default export */ var terms_and_conditions_TermsAndConditions = (TermsAndConditions);

;// CONCATENATED MODULE: ./blocks/terms-and-conditions/index.ts


;// CONCATENATED MODULE: ./assets/terms-and-conditions/header-image.webp
/* harmony default export */ var header_image = ({"src":"/_next/static/media/header-image.ba218e36.webp","height":1000,"width":1780,"blurDataURL":"data:image/webp;base64,UklGRj4AAABXRUJQVlA4IDIAAADQAQCdASoIAAQAAkA4JQBdgCKUiwtcyAD+7Ffc/PNmqJItncY9hWKrhb3wds1ZdPIAAA==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./pages/terms-and-conditions.tsx







var TermsAndConditionsPage = function(param) {
    var globalLayoutProps = param.globalLayoutProps, pageContent = param.pageContent, termsAndConditions = param.termsAndConditions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page_layout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageContent), {
            image: header_image,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_and_conditions_TermsAndConditions, {
                termsAndConditions: termsAndConditions
            })
        }))
    }));
};
var __N_SSG = true;
/* harmony default export */ var terms_and_conditions = (TermsAndConditionsPage);


/***/ }),

/***/ 51691:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"termsAndConditions":"_TermsAndConditions_termsAndConditions__VBYSo","textContentSection":"_TermsAndConditions_textContentSection__XNxxS","textContent":"_TermsAndConditions_textContent__A6Apb","accordionListContainer":"_TermsAndConditions_accordionListContainer__8rWiS","accordionListItemInnerList":"_TermsAndConditions_accordionListItemInnerList__jKhfE","accordionListItemSubtitle":"_TermsAndConditions_accordionListItemSubtitle__Ikirq","accordionListItemDescription":"_TermsAndConditions_accordionListItemDescription__J2ZYQ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,5675,5156,4520,4713,9774,2888,179], function() { return __webpack_exec__(68226); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);